import { all, put, cancelled, call, takeEvery } from 'redux-saga/effects';
import { FETCH_CANCEL,
  SHOW_NOTIFICATION,
  ANALYTICS_SUCCESS, ANALYTICS_REQUEST, ANALYTICS_LOADING, ANALYTICS_ERROR, ANALYTICS_CANCEL
} from '../actions';

const getAnalytics = function* getAnalytics (provider, authProvider, action) {
  const { reportType, id, ...params } = action;
  try {
    yield all([
      put({ type: ANALYTICS_LOADING, reportType: reportType, id: id, params: params })
    ]);
    console.log('call report', authProvider, params.modelId);
    let report = yield call(provider, 'getAnalytics', reportType, params, authProvider);
    yield put({
      type: ANALYTICS_SUCCESS,
      report: report,
      reportType: reportType,
      id: id
    });
  } catch (error) {
    yield put({ 
      type: SHOW_NOTIFICATION, 
      payload: {
        message: error,
        type: 'error',
      }
    });
    yield put({ type: ANALYTICS_ERROR, error, id: id });
  } finally {
    if (yield cancelled()) {
      yield put({ type: ANALYTICS_CANCEL, id: id });
    }
  }
}

export default (provider, authProvider) => function* analytics() {
  yield all([
    takeEvery(ANALYTICS_REQUEST, getAnalytics, provider, authProvider),
  ]);
};